import React, { useEffect, useState } from 'react';
import { Tag, Loader2 } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

// Runner builder popout: the Quotation Type picked in the runner, editable here (same field).
export const QuotationTypeBar = ({ appraisal, roofType, onChanged }) => {
  const { api } = useAuth();
  const [items, setItems] = useState([]);
  const [value, setValue] = useState(appraisal?.quotation_type || '');
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');
  const category = (appraisal?.primary_quote_types || [])[0] || appraisal?.quote_type_ref || '';

  useEffect(() => { setValue(appraisal?.quotation_type || ''); }, [appraisal?.quotation_type]);
  useEffect(() => {
    const qs = new URLSearchParams({ roof_type: roofType || '', category }).toString();
    api.get(`/quote-types-catalog?${qs}`).then((r) => setItems(r.data?.items || [])).catch(() => setItems([]));
  }, [api, roofType, category]);

  const pick = async (ref) => {
    setValue(ref); setErr(''); setSaving(true);
    try { await api.patch(`/appraisals/${appraisal.id || appraisal._id}`, { quotation_type: ref }); onChanged && onChanged(); }
    catch (e) { setErr(e?.response?.data?.detail || 'Save failed'); }
    finally { setSaving(false); }
  };

  const refs = items.map((i) => i.ref || i);
  return (
    <div data-testid="embed-quotation-type-bar" className="rounded-md border border-indigo-200 bg-white px-4 py-2.5 flex items-center gap-3 flex-wrap">
      <Tag size={14} className="text-indigo-600" />
      <span className="text-xs font-semibold text-slate-700">Quotation Type</span>
      <select data-testid="embed-quotation-type-select" value={value} onChange={(e) => pick(e.target.value)} disabled={saving}
        className="text-sm border border-slate-300 rounded px-2 py-1 min-w-[260px] bg-white">
        <option value="" disabled>— pick —</option>
        {value && !refs.includes(value) && <option value={value}>{value}</option>}
        {refs.map((r) => <option key={r} value={r}>{r}</option>)}
      </select>
      <span className="text-[11px] text-slate-500">Same choice as in the runner — change it here or there.</span>
      {saving && <Loader2 size={13} className="animate-spin text-slate-400" />}
      {err && <span data-testid="embed-quotation-type-error" className="text-xs text-red-600">{err}</span>}
    </div>
  );
};
